"use client";
import "../overlays/overlay-class-names.js";
import { OverlayFrame as e } from "../overlays/OverlayFrame.js";
import { Skeleton as t } from "../skeleton/Skeleton.js";
import { usePopoverState as n } from "./usePopoverState.js";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
import a from "clsx";
import { useId as o, useRef as s } from "react";
import { Popover as c } from "@base-ui/react/popover";
import { PreviewCard as l } from "@base-ui/react/preview-card";
//#region src/components/popover/Popover.tsx
var u = "pf:box-border pf:flex pf:flex-col pf:w-[320px] pf:max-w-[calc(100vw-16px)] pf:max-h-[var(--available-height)] pf:min-w-0 pf:overflow-hidden pf:rounded-[10px] pf:border-[0.5px] pf:border-solid pf:border-soft-pearl-300 pf:bg-background pf:shadow-menu pf:font-body pf:text-copy-13 pf:text-soft-pearl-1000 pf:origin-[var(--transform-origin)] pf:outline-none", d = "pf:transition-[transform,opacity] pf:duration-(--pf-spring-snappy-duration) pf:data-[ending-style]:duration-[120ms] pf:data-[ending-style]:ease-(--pf-easing-out) pf:ease-(--pf-spring-snappy-easing) pf:motion-reduce:transition-opacity pf:motion-reduce:duration-(--pf-duration-fast) pf:motion-reduce:ease-(--pf-easing-out) pf:data-[starting-style]:opacity-0 pf:data-[ending-style]:opacity-0 pf:data-[side=bottom]:[--pf-popover-closed-transform:translateY(-4px)_scale(0.96)] pf:data-[side=top]:[--pf-popover-closed-transform:translateY(4px)_scale(0.96)] pf:data-[side=left]:[--pf-popover-closed-transform:translateX(4px)_scale(0.96)] pf:data-[side=right]:[--pf-popover-closed-transform:translateX(-4px)_scale(0.96)] pf:motion-safe:data-[starting-style]:[transform:var(--pf-popover-closed-transform)] pf:motion-safe:data-[ending-style]:[transform:scale(0.98)]";
function f(f) {
	let { trigger: p, title: m, description: h, positionConfig: g, children: _, className: v } = f, y = n(f), b = o(), x = s(null);
	return f.mode === "preview" ? /* @__PURE__ */ i(l.Root, {
		open: y.open,
		onOpenChange: y.handleOpenChange,
		children: [/* @__PURE__ */ r(l.Trigger, {
			render: p,
			delay: 150,
			closeDelay: 150
		}), /* @__PURE__ */ r(l.Portal, { children: /* @__PURE__ */ r(l.Positioner, {
			side: g?.side ?? "bottom",
			align: g?.align ?? "start",
			sideOffset: 4,
			collisionPadding: 8,
			className: "pf:z-[60]",
			children: /* @__PURE__ */ i(l.Popup, {
				"aria-labelledby": b,
				className: a(u, y.animate && d, "pf:p-xl pf:gap-lg pf:overflow-y-auto", v),
				children: [/* @__PURE__ */ i("div", {
					className: "pf:flex pf:items-center pf:gap-[10px] pf:min-w-0",
					children: [f.previewConfig?.leading && /* @__PURE__ */ r("span", {
						className: "pf:shrink-0",
						"aria-hidden": "true",
						children: f.previewConfig.leading
					}), /* @__PURE__ */ i("div", {
						className: "pf:min-w-0 pf:flex-1",
						children: [/* @__PURE__ */ r("h2", {
							id: b,
							className: "pf:m-0 pf:text-label-13 pf:font-medium pf:wrap-anywhere",
							children: m
						}), h && /* @__PURE__ */ r("div", {
							className: "pf:mt-xxs pf:text-copy-12 pf:text-soft-pearl-800 pf:wrap-anywhere",
							children: h
						})]
					})]
				}), f.loadingConfig?.isLoading ? /* @__PURE__ */ i("div", {
					role: "status",
					className: "pf:flex pf:flex-col pf:gap-md",
					children: [
						/* @__PURE__ */ r("span", {
							className: "pf:sr-only",
							children: f.loadingConfig.label ?? "Loading preview…"
						}),
						/* @__PURE__ */ r(t, { width: "100%" }),
						/* @__PURE__ */ r(t, { width: "70%" }),
						/* @__PURE__ */ r(t, { width: "50%" })
					]
				}) : /* @__PURE__ */ r("div", {
					className: "pf:min-w-0 pf:wrap-anywhere",
					children: _
				})]
			})
		}) })]
	}) : /* @__PURE__ */ i(c.Root, {
		open: y.open,
		onOpenChange: y.handleOpenChange,
		children: [/* @__PURE__ */ r(c.Trigger, { render: p }), /* @__PURE__ */ r(c.Portal, { children: /* @__PURE__ */ r(c.Positioner, {
			side: g?.side ?? "bottom",
			align: g?.align ?? "start",
			sideOffset: 4,
			collisionPadding: 8,
			className: "pf:z-[60]",
			children: /* @__PURE__ */ r(c.Popup, {
				ref: x,
				initialFocus: f.focusConfig?.initialFocusRef ?? (() => x.current?.querySelector("[data-overlay-body] input:not(:disabled),[data-overlay-body] button:not(:disabled),[data-overlay-body] textarea:not(:disabled)") ?? x.current),
				finalFocus: f.focusConfig?.returnFocusRef,
				className: a(u, y.animate && d, v),
				children: /* @__PURE__ */ r(e, {
					closeConfig: f.closeConfig,
					compact: !0,
					hideHeader: f.headerConfig?.visible === !1,
					heading: /* @__PURE__ */ r(c.Title, {
						className: "pf:m-0 pf:text-label-13 pf:font-medium pf:wrap-anywhere",
						children: m
					}),
					description: h && /* @__PURE__ */ r(c.Description, {
						render: /* @__PURE__ */ r("div", {}),
						className: "pf:m-0 pf:mt-xs pf:text-copy-13 pf:text-soft-pearl-900 pf:wrap-anywhere",
						children: h
					}),
					footerConfig: f.footerConfig,
					pending: !1,
					error: null,
					onClose: y.dismiss,
					onCancel: y.dismiss,
					children: _
				})
			})
		}) })]
	});
}
//#endregion
export { f as Popover };
